export default [
    {
        id: 0,
        bde_code: 0,
        name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
        name_en: '0 - Not applicable, the real estate is not a housing type',
        name_es: '0 - No se aplica, al no tratarse de vivienda'
    },
    {
        id: 1,
        bde_code: 1,
        name_ca: '1 - Habitatge unifamiliar aïllat',
        name_en: '1 - Detached single-family house',
        name_es: '1 - Vivienda unifamiliar aislada'
    },
    {
        id: 2,
        bde_code: 2,
        name_ca: '2 - Habitatge unifamiliar adossat',
        name_en: '2 - Terraced single-family house',
        name_es: '2 - Vivienda unifamiliar adosada'
    },
    {
        id: 3,
        bde_code: 3,
        name_ca: '3 - Habitatge en bloc plurifamiliar',
        name_en: '3 - Dwelling in a multi-family block',
        name_es: '3 - Vivienda en bloque plurifamiliar'
    }
]





// WEBPACK FOOTER //
// ./src/options/dwelling_types.js